module.exports = __webpack_public_path__ + "img/111.0668052b.jpeg";